<app-form-drawer [visible]="basicShow" [dismissible]="false" styleClass="client-form-drawer" (closed)="close()">
  <app-client-form
    *ngIf="basicShow"
    layout="drawer"
    variant="lead"
    [defaultCompanyId]="defaultCompanyId"
    [initialName]="initialName"
    (saved)="onSaved($event)"
    (cancelled)="close()"></app-client-form>
</app-form-drawer>
